export const coreEndpoints = {
  health: { method: 'get', path: '/' },
  addAssignees: { method: 'post', path: '/request/{requestId}/block/{canvasModelId}/assignees/add' },
  updateAssignees: { method: 'post', path: '/request/{requestId}/block/{canvasModelId}/assignees/update' },
  assignBlockToSingleUser: {
    method: 'post',
    path: '/request/{requestId}/block/{canvasModelId}/assignees/assign-to-single-user',
  },
  deleteEngagement: { method: 'post', path: '/deleteEngagement/{engagementId}' },
  stepData: { method: 'post', path: '/workflow-engine/step-data' },
  remindRequestStepAssignee: { method: 'post', path: '/remind-request-step-assignee' },
  listTasks: { method: 'post', path: '/tasks' },
  generateAiToneSuggestions: { method: 'post', path: '/ai/tone-suggestions' },
  generateAiForm: { method: 'post', path: '/ai/generate-form' },
  rollbackRequestToStep: { method: 'post', path: '/rollback-request-to-step' },
  createSmartTableFilter: { method: 'post', path: '/smart-table-filters' },
  createEsignDocument: { method: 'post', path: '/create-esign' },
  updateOrganisationStaticContent: { method: 'post', path: '/organisation-static-content/update' },
  getOrganisationStaticContent: { method: 'get', path: '/organisation-static-content/{type}' },
  getWorkflowIntakeFormTemplate: { method: 'get', path: '/workflow/{id}/intake-form-template' },
} as const
